import { useCallback, useRef } from 'react';
import { WEBSOCKET_URL } from "./apiConfig";
import useAuthService from "../hooks/useAuthService";

const useWebSocketManager = (endpoint, onmessage) => {
  const { refreshAccessToken } = useAuthService();
  const wsRef = useRef(null);

  const connect = useCallback(async () => {
    if (wsRef.current) {
      wsRef.current.close();
    }

    const accessExpiry = localStorage.getItem("access_token_expiry");
            if (accessExpiry && Date.now() > accessExpiry) {
                // Use the navigate parameter to handle redirection after refreshing the token
                await refreshAccessToken();
            }
    const token = localStorage.getItem("access_token");
    if (!token) {
      throw new Error("No access token available for WebSocket connection.");
    }

    const fullUrl = `${WEBSOCKET_URL}${endpoint}`;
    const newWs = new WebSocket(fullUrl);

    newWs.onopen = () => {
      newWs.send(JSON.stringify({ type: "auth", token }));
    };

    newWs.onerror = (error) => {
      console.error("WebSocket error:", error.message);
    };

    newWs.onmessage = onmessage

    wsRef.current = newWs;
  }, [refreshAccessToken, onmessage, endpoint]);

  const sendMessage = useCallback((message) => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(message));
    }
  }, []);

  const refreshConnection = useCallback(async () => {
    await refreshAccessToken();
    if (wsRef.current) {
      wsRef.current.close();
    }
    connect();
  }, [connect, refreshAccessToken]);

  return { wsRef, sendMessage, refreshConnection, disconnect: () => wsRef.current?.close(), connect };
};

export default useWebSocketManager;